export default "__VITE_PUBLIC_ASSET__a72cf925__"